/**
 * Common Translations Module (Spanish)
 * Matches English structure exactly
 * @module common
 * @language es
 */

export const common = {
  nav: {
    // 1. Overview (standalone)
    overview: "Visión General",
    
    // 2. Youth Futures (dropdown parent)
    youthFutures: "Futuros de la Juventud",
    // Youth Futures dropdown items
    impactMetrics: "Impacto y Métricas",
    mentalHealth: "Dimensión Salud Mental",
    workforceEducation: "Fuerza Laboral y Educación",
    entrepreneurshipSupport: "Dimensión Emprendimiento",
    
    // 3. Database (dropdown parent)
    database: "Base de Datos",
    // Database dropdown items
    memberInsights: "Perspectivas de Miembros",
    programsEvents: "Programas y Eventos",
    technologyFuture: "Tecnología y Futuro",
    regionalAnalysis: "Análisis Regional",
    
    // 4. Vision 2040 (standalone)
    vision2040: "Visión 2040",
    
    // 5. Know More (dropdown parent)
    knowMore: "Saber Más",
    // Know More dropdown items
    methodology: "Metodología",
    contributing: "Contribuir",
    faq: "Preguntas Frecuentes",
    
    // Additional nav items
    backToTop: "Volver arriba",
    brandName: "JCI Vision Pulse",
    observatoryTitle: "Observatorio de Futuros de la Juventud",
    developmentCouncils: "Consejos de Desarrollo"
  },
  footer: {
    copyright: "© 2025 Consejos de Desarrollo JCI. Licenciado bajo CC BY-NC-SA.",
    methodology: "Metodología basada en datos de 147.424 miembros JCI globalmente.",
    poweredBy: "Desarrollado por",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio"
  },
  settings: {
    title: "Configuración",
    subtitle: "Administre sus preferencias y personalice su experiencia.",
    appearance: "Apariencia",
    appearanceDescription: "Personalice cómo se ve el observatorio en su dispositivo.",
    light: "Claro",
    dark: "Oscuro",
    system: "Sistema",
    language: "Idioma",
    languageDescription: "Seleccione su idioma preferido para la interfaz.",
    notifications: "Notificaciones",
    notificationsDescription: "Configure cómo desea recibir actualizaciones y alertas.",
    emailNotifications: "Notificaciones por Email",
    emailNotificationsDescription: "Reciba actualizaciones e informes por email.",
    pushNotifications: "Notificaciones Push",
    pushNotificationsDescription: "Reciba alertas en tiempo real en su navegador.",
    productUpdates: "Actualizaciones de Producto",
    productUpdatesDescription: "Manténgase informado sobre nuevas funciones y mejoras.",
    preferencesUpdated: "Preferencias actualizadas",
    notificationsEnabled: "notificaciones activadas",
    notificationsDisabled: "notificaciones desactivadas",
    themeUpdated: "Tema actualizado",
    themeChangedTo: "Tema cambiado a",
    languageUpdated: "Idioma actualizado",
    languageChangedTo: "Idioma cambiado a",
    profile: "Tu Perfil",
    profileDescription: "Información de tu cuenta",
    clickToChangeAvatar: "Haz clic en el avatar para cambiar",
    avatar: {
      error: "Error",
      loginRequired: "Debes iniciar sesión para subir un avatar",
      invalidType: "Tipo de archivo inválido",
      selectImage: "Por favor selecciona un archivo de imagen",
      tooLarge: "Imagen muy grande",
      selectSmaller: "Por favor selecciona una imagen más pequeña (máx. 100KB después de comprimir)",
      updated: "Avatar actualizado",
      updatedSuccess: "Tu foto de perfil ha sido actualizada exitosamente",
      uploadFailed: "Error al subir",
      failedToUpload: "Error al subir el avatar"
    },
    observatoryLens: "Lente del Observatorio",
    observatoryLensDescription: "Tus preferencias personalizadas de enfoque de datos",
    primaryInterest: "Interés Principal",
    focusCountry: "País de Enfoque",
    refineLens: "Refinar Lente del Observatorio",
    translationDebug: "Depurador de Traducción",
    translationDebugDescription: "Ver claves de traducción faltantes y estado de completitud",
    dangerZone: "Zona de Peligro",
    dangerZoneDescription: "Acciones irreversibles que afectan tu cuenta",
    deleteAccount: "Eliminar Cuenta",
    deleteAccountDescription: "Eliminar permanentemente tu cuenta y todos los datos asociados",
    deleteAccountConfirmTitle: "¿Eliminar tu cuenta?",
    deleteAccountConfirmDescription: "Esta acción no se puede deshacer. Todos tus datos serán eliminados permanentemente, incluyendo:",
    deleteAccountDataProfile: "Tu información de perfil",
    deleteAccountDataNotifications: "Preferencias e historial de notificaciones",
    deleteAccountDataAvatar: "Tu foto de perfil",
    deleteAccountDataProgress: "Progreso y logros del observatorio",
    typeEmailConfirm: "Escribe tu email para confirmar:",
    deleteAccountButton: "Eliminar Mi Cuenta Permanentemente",
    accountDeleted: "Cuenta Eliminada",
    accountDeletedDescription: "Tu cuenta y todos los datos asociados han sido eliminados permanentemente.",
    deleteFailed: "Fallo en la Eliminación",
    deleteFailedDescription: "No se pudo eliminar tu cuenta. Por favor intenta de nuevo o contacta soporte.",
    emailMismatch: "El email no coincide",
    // Privacy & Data Export
    privacyData: "Privacidad y Datos",
    privacyDataDescription: "Gestiona tus datos personales y configuración de privacidad",
    downloadData: "Descargar Tus Datos",
    downloadDataDescription: "Exporta todos tus datos personales en formato JSON (perfil, notificaciones, preferencias)",
    downloadAsJson: "Descargar como JSON",
    downloading: "Preparando descarga...",
    downloadComplete: "Descarga Completa",
    downloadCompleteDescription: "Tus datos personales se han descargado correctamente.",
    downloadFailed: "Descarga Fallida",
    downloadFailedDescription: "No se pudieron exportar tus datos. Por favor intenta de nuevo.",
    cancel: "Cancelar",
    // Data Processing Record - GDPR Article 30
    processingRecord: {
      title: "Registro de Procesamiento de Datos",
      activitiesRecorded: "actividades de procesamiento registradas",
      view: "Ver Registro",
      hide: "Ocultar Registro",
      noActivities: "No hay actividades de procesamiento registradas aún",
      legalBasisLabel: "Base Legal",
      showMore: "Mostrar {{count}} más",
      showLess: "Mostrar menos",
      gdprNote: "Según el Artículo 30 del RGPD, tienes derecho a acceder a los registros de todas las actividades de procesamiento de datos en tu cuenta.",
      activityTypes: {
        accountCreated: "Cuenta creada",
        profileUpdated: "Información de perfil actualizada",
        onboardingCompleted: "Incorporación completada",
        achievementUnlocked: "Logro desbloqueado",
        preferencesCreated: "Preferencias de notificación configuradas",
        preferencesUpdated: "Preferencias de notificación actualizadas",
        notificationSent: "Notificación enviada",
        notificationRead: "Notificación leída",
        roleAssigned: "Rol asignado"
      },
      legalBasis: {
        consent: "Consentimiento",
        contractPerformance: "Ejecución del contrato",
        legitimateInterest: "Interés legítimo"
      }
    }
  },
  progress: {
    title: "Maestría del Observatorio",
    description: "Sigue tu recorrido por el Observatorio",
    emailVerified: "Email verificado",
    visitedModules: "Visitaste",
    modules: "módulos",
    setupComplete: "Configuración completa",
    observer: "Observador",
    analyst: "Analista",
    visionary: "Visionario"
  },
  notifications: {
    title: "Notificaciones",
    empty: "Sin notificaciones aún",
    viewSettings: "Configuración de Notificaciones",
    markAllRead: "Marcar todas como leídas",
    preferences: "Preferencias de Notificación",
    preferencesDescription: "Controla cómo recibes los informes de inteligencia",
    emailAlerts: "Alertas por Email",
    emailAlertsDescription: "Recibe Informes Estratégicos de Inteligencia por email",
    inAppAlerts: "Alertas en la App",
    inAppAlertsDescription: "Mostrar notificaciones toast al iniciar sesión",
    weeklyDigest: "Resumen Semanal",
    weeklyDigestDescription: "Recibe un resumen de inteligencia cada semana",
    intelBriefing: "📊 Nueva Información Disponible",
    deleteAll: "Eliminar Todo",
    deleteAllConfirm: "¿Eliminar Todas las Notificaciones?",
    deleteAllDescription: "Esto eliminará permanentemente todo tu historial de notificaciones. Esta acción no se puede deshacer.",
    deleteAllButton: "Eliminar Todas las Notificaciones",
    deleted: "Notificaciones eliminadas",
    deletedDescription: "Todas tus notificaciones han sido eliminadas permanentemente.",
    deleteError: "Error al eliminar",
    deleteErrorDescription: "No se pudieron eliminar las notificaciones. Inténtalo de nuevo.",
    cancel: "Cancelar",
    deletedSingle: "Notificación eliminada",
    swipeHint: "Desliza a la izquierda para eliminar"
  },
  roles: {
    admin: "Administrador",
    administrator: "Administrador",
    moderator: "Moderador",
    user: "Usuario",
  },
  interests: {
    "mental health": "Salud Mental",
    "mental-health": "Salud Mental",
    "workforce preparation": "Preparación Laboral",
    "workforce-preparation": "Preparación Laboral",
    "entrepreneurship": "Emprendimiento",
    "technology adoption": "Adopción Tecnológica",
    "technology-adoption": "Adopción Tecnológica",
    "regional analysis": "Análisis Regional",
    "regional-analysis": "Análisis Regional",
  },
  mastery: {
    observer: "Observador",
    analyst: "Analista",
    visionary: "Visionario",
  },
  visibility: {
    membersOnly: "SOLO MIEMBROS",
    adminOnly: "SOLO ADMIN",
    hiddenAdminOnly: "OCULTO (solo admin)",
  },
  admin: {
    sendBriefing: "Enviar Informe de Inteligencia",
    sendBriefingDescription: "Envía un Informe Estratégico de Inteligencia a usuarios suscritos",
    module: "Módulo",
    selectModule: "Selecciona un módulo",
    briefingTitle: "Título",
    titlePlaceholder: "Ej: Nuevos Datos de Salud Mental Publicados",
    summary: "Resumen",
    summaryPlaceholder: "Breve descripción de la nueva inteligencia...",
    sendToSubscribers: "Enviar a Suscriptores",
    recipientNote: "Los destinatarios son usuarios con interés principal coincidente que tienen alertas por email habilitadas",
    fillAllFields: "Por favor complete todos los campos",
    briefingSent: "Informe Enviado",
    sentTo: "Enviado a",
    subscribers: "suscriptores",
    sendFailed: "Error al enviar el informe",
    briefingSentTo: "Informe enviado a",
    users: "usuarios",
    sending: "Enviando...",
    // API Key Management
    apiKeys: {
      title: "Claves API",
      description: "Administra claves API para acceso externo a datos YFI",
      create: "Crear Clave API",
      createTitle: "Crear Nueva Clave API",
      createDescription: "Crea una nueva clave API para que software externo acceda a la API de datos YFI.",
      name: "Nombre",
      namePlaceholder: "Ej: Mi Aplicación",
      keyDescription: "Descripción",
      descriptionPlaceholder: "¿Para qué se usará esta clave?",
      expiration: "Expiración",
      never: "Nunca expira",
      days30: "30 días",
      days90: "90 días",
      months6: "6 meses",
      year1: "1 año",
      cancel: "Cancelar",
      creating: "Creando...",
      created: "Clave API Creada",
      createdDescription: "Tu nueva clave API ha sido creada. Cópiala ahora - no se mostrará de nuevo.",
      saveKeyWarning: "¡Guarda tu clave API ahora!",
      saveKeyDescription: "Esta es la única vez que verás esta clave. Cópiala y guárdala de forma segura.",
      savedKey: "He guardado mi clave",
      revoke: "Revocar",
      revokeTitle: "Revocar Clave API",
      revokeDescription: "¿Estás seguro de que quieres revocar esta clave? Esta acción no se puede deshacer. Las aplicaciones que usen esta clave perderán acceso inmediatamente.",
      revoking: "Revocando...",
      revoked: "Clave API Revocada",
      revokedDescription: "La clave API ha sido revocada y ya no puede usarse.",
      noKeys: "Sin claves API todavía",
      noKeysDescription: "Crea tu primera clave API para comenzar.",
      active: "Activa",
      expired: "Expirada",
      created_at: "Creada",
      lastUsed: "Último uso",
      requests: "solicitudes",
      viewDocs: "Consulta la Guía de Integración API para documentación sobre el uso de estas claves.",
      failedToLoad: "Error al cargar claves API",
      failedToCreate: "Error al crear clave API",
      failedToRevoke: "Error al revocar clave API"
    },
    // Data Administration
    dataAdmin: {
      title: "Administración de Datos",
      description: "Monitorea y gestiona los datos del observatorio",
      refresh: "Actualizar",
      coverage: "Cobertura de Perfiles de País",
      coverageDescription: "de países tienen perfiles detallados",
      databaseTables: "Tablas de Base de Datos",
      yfiCountries: "Países YFI",
      yfiCountriesDesc: "Países con puntuaciones YFI",
      countryProfiles: "Perfiles de País",
      countryProfilesDesc: "Datos detallados por país",
      jciStats: "Estadísticas JCI",
      jciStatsDesc: "Métricas organizacionales globales",
      regions: "Regiones",
      regionsDesc: "Regiones JCI",
      activeApiKeys: "Claves API Activas",
      activeApiKeysDesc: "Acceso de software externo",
      apiRequests: "Solicitudes API",
      apiRequestsDesc: "Total de solicitudes registradas",
      countryProfilesTitle: "Perfiles de País",
      published: "publicados",
      draft: "Borrador",
      updated: "Actualizado",
      noProfiles: "No hay perfiles de país creados todavía",
      quickActions: "Acciones Rápidas",
      viewYfiRankings: "Ver Rankings YFI",
      regionalAnalysis: "Análisis Regional",
      backendNote: "Para gestión avanzada de base de datos, accede al panel de Lovable Cloud desde la configuración del proyecto."
    }
  },
  featuredInsight: {
    title: "Tu País de Enfoque",
    fiiScore: "Índice de Futuros de la Juventud",
    globalAverage: "Promedio Global",
    viewFullRankings: "Ver Índice Completo",
    unlockTitle: "Desbloquea Tus Insights Personalizados",
    unlockDescription: "Completa la configuración para ver cómo tu país de enfoque se compara con el promedio global en todas las dimensiones del YFI."
  },
  header: {
    title: "Observatorio de Futuros de la Juventud de los Consejos de Desarrollo JCI",
    subtitle: "Observatorio Global de los Consejos de Desarrollo",
    tagline: "Desarrollando Líderes para un Mundo Cambiante"
  },
  common: {
    jan: "Ene",
    feb: "Feb",
    mar: "Mar",
    apr: "Abr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Ago",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dic",
    preferredProgramTypes: "Tipos de Programa Preferidos",
    preferredEventFormat: "Formato de Evento Preferido",
    regionalPreferences: "Preferencias Regionales",
    inPerson: "Presencial",
    online: "En Línea",
    hybrid: "Híbrido",
    networking: "Networking",
    development: "Desarrollo",
    leadership: "Liderazgo",
    search: "Buscar",
    settings: "Configuración",
    signIn: "Iniciar Sesión",
    signOut: "Cerrar Sesión",
    toggleMenu: "Alternar menú de navegación",
    scrollToTop: "Desplazarse arriba",
    source: "Fuente",
    sources: {
      membership2025: "Membresía JCI 2025",
      impactReport2025: "Informe de Impacto JCI 2025"
    },
    loading: "Cargando...",
    noDataAvailable: "Datos no disponibles",
    noDataDescription: "Los datos se están cargando o no están disponibles en este momento.",
    errorLoadingChart: "Error al cargar gráfico",
    months: {
      jan: "Ene",
      feb: "Feb",
      mar: "Mar",
      apr: "Abr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Ago",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dic"
    }
  },
  ui: {
    notFound: {
      title: "404",
      message: "¡Ups! Página no encontrada",
      returnHome: "Volver al Inicio"
    },
    keyboardShortcuts: {
      title: "Atajos de Teclado",
      toggleDarkMode: "Alternar modo oscuro/claro",
      cycleLanguages: "Cambiar idiomas",
      openSearch: "Abrir búsqueda",
      showShortcuts: "Mostrar atajos de teclado",
      ctrlOrCmd: "Use Ctrl en Windows/Linux o ⌘ en Mac"
    },
    commandPalette: {
      searchPlaceholder: "Buscar páginas...",
      noResults: "No se encontraron resultados.",
      pagesHeading: "Páginas"
    },
    languageToggle: {
      selectLanguage: "Seleccionar idioma",
      changeLanguage: "Cambiar idioma"
    }
  },
  charts: {
    noDataAvailable: "Datos no disponibles",
    dataLoadingSoon: "Los datos se cargarán pronto",
    noFunnelData: "Datos de embudo no disponibles",
    configureProcessData: "Configure los datos del proceso",
    radarUnavailable: "Datos de radar no disponibles",
    configurePerformanceIndicators: "Configure indicadores de rendimiento",
    performanceUnavailable: "Datos de rendimiento no disponibles",
    configureTrendData: "Configure datos de tendencia",
    currentProgress: "Progreso Actual",
    goal2040: "Meta 2040",
    mainValue: "Valor Principal",
    trend: "Tendencia",
    goal: "Meta",
    fiiScore: "Puntuación YFI",
    score: "Puntuación",
    value: "Valor",
    percentage: "Porcentaje",
    region: "Región",
    country: "País",
    members: "Miembros",
    year: "Año",
    month: "Mes",
    count: "Recuento",
    total: "Total",
    current: "Actual",
    projected: "Proyectado",
    average: "Promedio"
  },
  metrics: {
    membersActive: "Miembros Activos",
    countriesPresent: "Países Presentes",
    startupsSupported: "Startups Apoyadas",
    sustainableProjects: "Proyectos Sostenibles",
    completed: "completado",
    countries: "Países",
    members: "Miembros",
    projects: "Proyectos",
    projectsPerYear: "Proyectos/año",
    memberDensity: "Densidad de Miembros",
    country: "País",
    regionalDistribution: "Distribución Regional",
    globalPresence: "Presencia global de JCI en 2025",
    activeMembers: "Miembros Activos",
    globally: "globalmente",
    worldwidePresence: "presencia mundial",
    communities: "Comunidades",
    activeCommunities: "comunidades activas",
    yearsOfHistory: "Años de Historia",
    since1915: "desde 1915",
    vs2024: "vs 2024",
    annualProjects: "Proyectos Anuales",
    in2025: "en 2025"
  },
  index: {
    heroTitle: "Observatorio de Futuros Juveniles de los Consejos de Desarrollo JCI",
    heroSubtitle: "Midiendo Liderazgo Juvenil, Salud Mental y Oportunidad Económica Globalmente",
    heroDescription: "Una plataforma impulsada por datos que analiza las condiciones para jóvenes líderes en 114 países.",
    globalImpactTitle: "Impacto Global de un Vistazo",
    verifiedData: "Datos verificados del Informe de Impacto JCI 2025",
    globalMembers: "Miembros Globales",
    activeWorldwide: "Activos mundialmente",
    projects: "Proyectos",
    period20242025: "Período: 2024-2025",
    volunteerHours: "Horas de Voluntariado",
    hoursContributed: "Horas contribuidas",
    countries: "Países",
    worldwidePresence: "Presencia mundial",
    localOrganizations: "Organizaciones Locales",
    activeCommunities: "Comunidades activas",
    digitalReachTitle: "Alcance y Huella Digital",
    totalFollowers: "Seguidores Totales",
    jciccUsers: "Usuarios jci.cc",
    memberDemographicsTitle: "Instantánea de Demografía de Miembros",
    averageAge: "Edad Promedio",
    yearsOld: "Años",
    universityEducated: "Educación Universitaria",
    bachelorsOrHigher: "Licenciatura o superior",
    fullTime: "Tiempo completo",
    entrepreneurs: "Emprendedores",
    employmentStatus: "Estado de Empleo"
  },
  globalPresenceMap: {
    title: "Presencia Global JCI",
    subtitle: "Activos en 114 Países en 4 Regiones",
    countriesLabel: "países",
    regionsLabel: "regiones",
    countriesCount: "Países",
    membersCount: "Miembros",
    localOrgs: "Orgs Locales",
    regions: {
      asiaPacific: "Asia y el Pacífico",
      europe: "Europa",
      africaMe: "África y Oriente Medio",
      americas: "América"
    }
  },
  mentalHealth: {
    serviceCoverageGap: "Brecha de cobertura de servicios del 30-40% entre EE.UU./Canadá y América Latina",
    criticalGap: "Brecha crítica: solo 10-30% de cobertura de servicios vs 70%+ en Europa",
    onlyTrained: "(solo {percentage}% capacitados)"
  },
  memberInsights: {
    alumniInsight: "53% de nuevos miembros (1-3 años) aportan energía fresca mientras que 24% de veteranos (7+ años) proporcionan liderazgo y estabilidad central"
  },
  onboarding: {
    commandCenterSetup: "Configuración del Centro de Mando",
    stepOf: "Paso {{current}} de {{total}}",
    continue: "Continuar",
    back: "Atrás",
    completeSetup: "Completar Configuración",
    preferencesUpdated: "Preferencias Actualizadas",
    lensUpdated: "Tu lente del observatorio ha sido actualizada.",
    error: "Error",
    saveFailed: "Error al guardar tus preferencias. Inténtalo de nuevo.",
    identity: {
      title: "Confirma Tu Identidad",
      description: "Dinos quién eres y a qué organización JCI perteneces.",
      fullName: "Nombre Completo",
      fullNamePlaceholder: "Ingresa tu nombre completo",
      nationalOrg: "Organización Nacional JCI",
      nationalOrgPlaceholder: "Selecciona tu organización nacional...",
      searchCountry: "Buscar país...",
      noCountryFound: "País no encontrado.",
      localOrg: "Organización Local JCI",
      optional: "Opcional",
      localOrgPlaceholder: "Ej: JCI Ciudad de México, JCI Buenos Aires"
    },
    lens: {
      title: "Elige Tu Lente",
      description: "Selecciona tu área principal de interés. Esto personalizará tu experiencia en el panel.",
      mentalHealth: "Salud Mental",
      mentalHealthDesc: "Enfócate en bienestar psicológico, resiliencia e iniciativas de salud mental.",
      education: "Educación y Fuerza Laboral",
      educationDesc: "Explora resultados de aprendizaje, desarrollo de habilidades y tendencias de empleo.",
      entrepreneurship: "Emprendimiento",
      entrepreneurshipDesc: "Descubre la salud del ecosistema empresarial, actividad de startups y métricas de innovación."
    },
    benchmark: {
      title: "Establece Tu Benchmark",
      description: "Elige un país de enfoque para comparar con el Promedio Global del YFI en todo el panel.",
      focusCountry: "País de Enfoque",
      focusCountryPlaceholder: "Selecciona tu país de enfoque...",
      searchCountry: "Buscar país...",
      noCountryFound: "País no encontrado.",
      vsGlobal: "{{country}} vs Promedio Global",
      globalAverage: "Promedio Global",
      aboveAverage: "+{{value}} sobre el promedio global",
      belowAverage: "-{{value}} bajo el promedio global"
    },
    config: {
      ready: "¡Listo para Lanzar!",
      configuring: "Configurando Tu Centro de Mando",
      step1: "Analizando tus preferencias...",
      step2: "Configurando diseño del panel...",
      step3: "Cargando insights personalizados...",
      step4: "Preparando tu Centro de Mando..."
    }
  },
  fiiClassifications: {
    excellent: "Excelente",
    good: "Bueno",
    moderate: "Moderado",
    deficient: "Deficiente",
    critical: "Crítico"
  },
  regions: {
    asiaPacific: "Asia y el Pacífico",
    europe: "Europa",
    americas: "América",
    africaMiddleEast: "África y Oriente Medio"
  },
  access: {
    exclusiveMemberInsight: "Insight Exclusivo para Miembros",
    adminOnlyModule: "Módulo Solo para Administradores",
    joinCTA: "Únete al Observatorio de Futuros Juveniles de los Consejos de Desarrollo JCI para desbloquear la base de datos completa, insights y proyecciones.",
    adminOnlyMessage: "Este contenido {{moduleLabel}} está disponible solo para administradores.",
    joinNowLogin: "Únete Ahora / Iniciar Sesión",
    backToDashboard: "Volver al Panel",
    memberAccess: "Acceso de Miembros",
    passwordlessEntry: "Entrada sin contraseña con Magic Link o Google.",
    joinObservatory: "Únete al Observatorio",
    unlockDescription: "Desbloquea insights exclusivos para miembros, proyecciones y módulos interactivos.",
    email: "Correo Electrónico",
    emailPlaceholder: "tu@empresa.com",
    sendMagicLink: "Enviar Magic Link",
    continueWithGoogle: "Continuar con Google",
    authDisclaimer: "Al continuar, aceptas recibir correos electrónicos de autenticación.",
    signingIn: "Iniciando sesión...",
    checkInbox: "Revisa tu bandeja de entrada",
    magicLinkSent: "Te enviamos un enlace mágico seguro para iniciar sesión.",
    invalidEmail: "Correo electrónico inválido",
    invalidEmailDescription: "Por favor, ingresa una dirección de correo electrónico válida.",
    loginFailed: "Error al iniciar sesión",
    googleLoginFailed: "Error al iniciar sesión con Google"
  },
  chatJCI: {
    title: "ChatJCI",
    openChat: "Abrir chat",
    closeChat: "Cerrar chat",
    placeholder: "Escribe tu pregunta...",
    send: "Enviar mensaje",
    thinking: "Pensando...",
    greeting: "¡Hola, {{name}}! ¿Cómo puedo ayudarte hoy?",
    defaultName: "amigo",
    fallbackMessage: "Lo siento, no pude encontrar esa información en mi base de conocimiento.",
    errorMessage: "Lo siento, algo salió mal. Por favor, intenta de nuevo.",
    rateLimitMessage: "Demasiadas solicitudes. Por favor, espera un momento antes de intentar de nuevo.",
    authRequired: "Por favor, inicia sesión para usar ChatJCI.",
    welcomeSubtitle: "Pregúntame sobre programas de JCI, membresía o Visión 2040",
    newChat: "Nueva Conversación",
    poweredBy: "Desarrollado por Google Gemini",
    suggestedPrompts: {
      title: "Prueba preguntar sobre:",
      vision2040: "¿Qué es la Visión 2040 de JCI?",
      risePrograms: "Cuéntame sobre los programas JCI RISE",
      membership: "¿Cómo puedo ser miembro de JCI?",
      councils: "¿Qué son los Consejos de Desarrollo?",
      youthIndex: "Explica el Índice de Futuros Juveniles"
    },
    loginRequired: {
      title: "Inicia Sesión para Chatear",
      description: "ChatJCI está disponible exclusivamente para miembros de JCI. Inicia sesión para comenzar una conversación.",
      action: "Iniciar Sesión"
    },
    locked: {
      title: "Asistente de IA Solo para Miembros",
      description: "ChatJCI es tu guía personal de IA para programas de JCI, Visión 2040 y el Índice de Futuros Juveniles. Inicia sesión para comenzar una conversación."
    },
    sidebar: {
      newChat: "Nueva Conversación",
      today: "Hoy",
      yesterday: "Ayer",
      last7Days: "Últimos 7 Días",
      older: "Anteriores",
      noConversations: "Sin conversaciones aún",
      searchPlaceholder: "Buscar conversaciones...",
      noResults: "No se encontraron conversaciones",
      deleteConversation: "¿Eliminar conversación?",
      deleteConfirmation: "Esto eliminará permanentemente esta conversación y todos sus mensajes.",
      delete: "Eliminar",
      renameConversation: "Renombrar",
      exportAll: "Exportar Todas las Conversaciones"
    },
    export: {
      asJson: "Exportar como JSON",
      asMarkdown: "Exportar como Markdown",
      downloading: "Preparando descarga...",
      success: "Conversaciones exportadas",
      singleSuccess: "Conversación exportada",
      successDescription: "Tu historial de chat se ha descargado correctamente",
      error: "Error de exportación",
      errorDescription: "No se pudieron exportar las conversaciones. Inténtalo de nuevo.",
      noConversations: "Sin conversaciones para exportar"
    },
    copy: {
      tooltip: "Copiar al portapapeles",
      success: "Conversación copiada",
      successDescription: "Markdown copiado. ¡Pégalo donde quieras!",
      error: "Error al copiar",
      errorDescription: "No se pudo copiar. Inténtalo de nuevo.",
      noMessages: "Sin mensajes para copiar"
    },
    share: {
      button: "Compartir",
      dialogTitle: "Compartir Conversación",
      dialogDescription: "Cualquiera con este enlace puede ver esta conversación.",
      createLink: "Crear Enlace",
      generating: "Generando enlace...",
      created: "Enlace creado",
      createdDescription: "Tu conversación ahora se puede compartir",
      linkCopied: "Enlace copiado",
      copyError: "Error al copiar enlace",
      revokeShare: "Revocar",
      revoked: "Revocado",
      revokedDescription: "Este enlace ya no funcionará",
      revokeError: "Error al revocar",
      createError: "Error al crear",
      createErrorDescription: "No se pudo crear el enlace. Inténtalo de nuevo.",
      publicNote: "Cualquiera con el enlace puede ver esta conversación",
      viewCount: "{{count}} vistas",
      views: "vistas",
      expiresAt: "Expira el {{date}}",
      expirationLabel: "El enlace expira en",
      days7: "7 días",
      days30: "30 días",
      days90: "90 días"
    },
    sharedView: {
      title: "Conversación ChatJCI Compartida",
      sharedBy: "Compartido por Miembro JCI",
      sharedOn: "Compartido el {{date}}",
      signUpCta: "¿Quieres tu propio asistente de IA?",
      signUpButton: "Regístrate en ChatJCI",
      notFound: "Conversación no encontrada",
      notFoundDescription: "Este enlace puede haber expirado o sido revocado.",
      expired: "Este enlace ha expirado"
    },
    message: {
      copy: "Copiar",
      copied: "¡Copiado!",
      regenerate: "Regenerar",
      edit: "Editar",
      stopGenerating: "Detener",
      editPlaceholder: "Edita tu mensaje...",
      cancel: "Cancelar",
      saveAndSubmit: "Guardar y Enviar"
    },
    streaming: {
      generating: "Generando...",
      stopped: "Detenido"
    }
  },
  errorBoundary: {
    title: "Algo salió mal",
    description: "Disculpe las molestias. Ha ocurrido un error inesperado.",
    tryAgain: "Intentar de Nuevo",
    goHome: "Ir al Inicio",
    errorDetails: "Detalles del Error (Solo Desarrollo)",
    helpText: "Si este problema persiste, por favor actualice la página o contacte con soporte.",
    chunkLoadError: {
      title: "Error al Cargar Página",
      description: "La página no pudo ser cargada. Esto puede deberse a un problema de red o caché desactualizado.",
      retry: "Intentar de Nuevo",
      retryMessage: "Intento {{current}} de {{max}}",
      maxRetries: "Se alcanzó el número máximo de intentos."
    }
  },
  gdpr: {
    cookieTitle: "Preferencias de Cookies",
    cookieDescription: "Usamos cookies para analizar el uso del sitio y mejorar tu experiencia. Tus datos nunca se venden a terceros.",
    learnMore: "Conoce más sobre nuestras prácticas de privacidad",
    accept: "Aceptar",
    decline: "Rechazar",
    analyticsTitle: "Analytics y Cookies",
    analyticsDescription: "Administra cómo usamos cookies y analytics para mejorar tu experiencia",
    allowAnalytics: "Permitir Analytics",
    allowAnalyticsDescription: "Ayúdanos a mejorar compartiendo datos anónimos de uso",
    analyticsEnabled: "Analytics Habilitado",
    analyticsEnabledDescription: "Ahora puedes ayudarnos a mejorar la plataforma con datos anónimos de uso.",
    analyticsDisabled: "Analytics Deshabilitado",
    analyticsDisabledDescription: "Tus datos de uso ya no serán recopilados.",
    whatWeCollect: "Lo que recopilamos:",
    collectItem1: "Vistas de página y patrones de navegación",
    collectItem2: "Interacción con funciones y profundidad de desplazamiento",
    collectItem3: "Información anónima del dispositivo y navegador",
    neverCollect: "Nunca recopilamos información personal ni vendemos tus datos a terceros."
  },
  apiDocs: {
    badge: "API para Desarrolladores",
    hero: {
      title: "API del Observatorio de Futuros de la Juventud",
      subtitle: "Accede a datos completos sobre desarrollo juvenil de 114 países. Crea aplicaciones, visualizaciones e integra métricas YFI en tus proyectos.",
      getAccess: "Obtener Acceso a la API",
      viewDocs: "Ver Especificación OpenAPI"
    },
    stats: {
      countries: "Países",
      statistics: "Estadísticas",
      endpoints: "Endpoints"
    },
    features: {
      badge: "Por Qué Usar Nuestra API",
      title: "Hecho para Desarrolladores",
      subtitle: "Nuestra API proporciona acceso confiable y bien documentado a métricas integrales de desarrollo juvenil. Ya sea que estés construyendo herramientas de investigación, dashboards o visualizaciones de datos — te tenemos cubierto.",
      sampleRequest: "Solicitud de Ejemplo",
      restful: {
        title: "API RESTful JSON",
        description: "Endpoints REST estándar que devuelven respuestas JSON limpias y predecibles. Fácil integración con cualquier lenguaje de programación o plataforma."
      },
      filtering: {
        title: "Filtrado Completo",
        description: "Filtra datos por región, clasificación, rangos de puntuación y más. Obtén exactamente los datos que necesitas con potentes parámetros de consulta.",
        highlight: "15+ Filtros"
      },
      pagination: {
        title: "Paginación y Ordenamiento",
        description: "Maneja grandes conjuntos de datos eficientemente con paginación integrada. Ordena por cualquier campo en orden ascendente o descendente.",
        highlight: "Basado en Offset"
      },
      auth: {
        title: "Claves API Seguras",
        description: "Claves con hash SHA-256 con límites de tasa por clave. Genera, revoca y monitorea claves desde tu panel."
      },
      logging: {
        title: "Registro de Solicitudes",
        description: "Analytics completo del uso de tu API. Rastrea conteos de solicitudes, tiempos de respuesta y tasas de error en tiempo real.",
        highlight: "Analytics"
      },
      cors: {
        title: "CORS Habilitado",
        description: "Solicitudes cross-origin soportadas de forma nativa. Construye aplicaciones basadas en navegador sin servidores proxy."
      }
    },
    auth: {
      badge: "Seguridad",
      title: "Autenticación",
      subtitle: "Todas las solicitudes API requieren autenticación mediante clave API. Sigue estos simples pasos para comenzar.",
      step1: {
        title: "Obtén Tu Clave API",
        description: "Navega a Configuración y genera una nueva clave API. Dale un nombre descriptivo para fácil gestión."
      },
      step2: {
        title: "Agregar a Headers",
        description: "Incluye tu clave API en el header X-API-Key con cada solicitud que hagas a nuestros endpoints."
      },
      step3: {
        title: "Comienza a Construir",
        description: "¡Estás listo! Haz solicitudes a cualquier endpoint y comienza a integrar datos YFI en tu aplicación."
      },
      headerExample: "Formato del Header"
    },
    endpoints: {
      badge: "Referencia de la API",
      title: "Endpoints Disponibles",
      subtitle: "Tres endpoints poderosos para acceder a todos los datos YFI. Cada endpoint soporta filtrado, ordenamiento y paginación.",
      parameters: "Parámetros de Consulta",
      sampleRequest: "Solicitud de Ejemplo",
      sampleResponse: "Respuesta de Ejemplo",
      yfi: {
        title: "Rankings YFI",
        description: "Accede a puntuaciones y rankings del Youth Futures Index para todos los países. Filtra por región, clasificación, ordena por cualquier dimensión y pagina resultados."
      },
      countries: {
        title: "Perfiles de Países",
        description: "Datos detallados por país incluyendo demografía, presencia JCI, indicadores de salud mental, datos de fuerza laboral y métricas de emprendimiento."
      },
      stats: {
        title: "Estadísticas Globales",
        description: "Estadísticas agregadas de JCI incluyendo conteo de miembros, distribución regional, métricas organizacionales y datos históricos."
      },
      indicators: {
        title: "Metadatos de Indicadores",
        description: "Obtén definiciones detalladas, metodologías y umbrales para todos los indicadores YFI. Sin autenticación requerida."
      },
      benchmarks: {
        title: "Benchmarks Regionales",
        description: "Benchmarks estadísticos por región incluyendo promedio, mediana, percentiles y países de mejor desempeño."
      }
    },
    params: {
      yfi: {
        region: "Filtrar por región JCI: amdec, adc, apdc, edc",
        classification: "Filtrar por nivel YFI: Excellent, Good, Moderate, Deficient, Critical",
        code: "Obtener país específico por código ISO de 2 letras (ej: BR, DE, JP)",
        sort: "Campo de ordenamiento: yfi_score, mental_health_score, workforce_score, entrepreneurship_score, country_name",
        order: "Dirección del ordenamiento: asc (ascendente) o desc (descendente)",
        limit: "Resultados por página (predeterminado: 100, máx: 1000)",
        offset: "Offset de paginación para obtener páginas subsiguientes",
        countryCodes: "Filtrar múltiples países por códigos ISO separados por coma (ej: BR,DE,JP)",
        fields: "Retornar solo campos específicos (ej: country_code,yfi_score,classification)"
      },
      countries: {
        slug: "Identificador del perfil del país (ej: brazil, germany)"
      },
      stats: {
        key: "Obtener estadística específica por su identificador único",
        category: "Filtrar por categoría: membership, regional, organizational"
      },
      indicators: {
        key: "Filtrar por clave específica del indicador (ej: YFI_SCORE, YFI_MENTAL)",
        category: "Filtrar por categoría del indicador: composite, mental_health, workforce, entrepreneurship",
        lang: "Código de idioma para nombres/descripciones traducidos (ej: pt, es, fr, ja)"
      },
      benchmarks: {
        region: "Código de región para benchmarks regionales: amdec, adc, apdc, edc",
        indicator: "Indicador específico para benchmark: yfi_score, mental_health_score, workforce_score, entrepreneurship_score",
        top: "Número de países de mejor desempeño a incluir (predeterminado: 5)"
      }
    },
    table: {
      parameter: "Parámetro",
      type: "Tipo",
      description: "Descripción"
    },
    responseFormat: {
      title: "Formato de Respuesta",
      subtitle: "Todos los endpoints devuelven una estructura JSON consistente con datos y metadatos.",
      structure: "Estructura de Respuesta Estándar",
      success: {
        title: "Array de Datos",
        description: "Los resultados se devuelven en el campo 'data' como un array (u objeto para solicitudes de ítem único)."
      },
      meta: {
        title: "Metadatos Incluidos",
        description: "Cada respuesta incluye info de paginación, ID de solicitud para debug y timestamp."
      }
    },
    errors: {
      title: "Manejo de Errores",
      subtitle: "La API usa códigos de estado HTTP estándar. Aquí están las respuestas de error más comunes que puedes encontrar.",
      "401": {
        title: "No Autorizado",
        description: "Clave API faltante, inválida o revocada. Verifica tu header X-API-Key."
      },
      "404": {
        title: "No Encontrado",
        description: "El recurso solicitado no existe. Verifica la ruta del endpoint y parámetros de consulta."
      },
      "405": {
        title: "Método No Permitido",
        description: "Solo se soportan solicitudes GET. Asegúrate de usar el método HTTP correcto."
      },
      "429": {
        title: "Límite de Tasa Excedido",
        description: "Has excedido tu límite de tasa. Espera el período de reset o aumenta los límites de tu clave."
      },
      "500": {
        title: "Error del Servidor",
        description: "Ocurrió un error inesperado. Contacta soporte con tu request_id para asistencia."
      }
    },
    useCases: {
      title: "Casos de Uso",
      subtitle: "Descubre cómo las organizaciones están usando datos YFI para generar impacto.",
      research: {
        title: "Investigación Académica",
        description: "Universidades e instituciones de investigación usan datos YFI para estudios comparativos sobre desarrollo juvenil."
      },
      journalism: {
        title: "Periodismo de Datos",
        description: "Organizaciones de noticias crean visualizaciones e historias impactantes sobre tendencias globales de la juventud."
      },
      ngo: {
        title: "Planificación de ONGs",
        description: "Organizaciones sin fines de lucro usan insights regionales para planificar intervenciones y asignar recursos efectivamente."
      },
      policy: {
        title: "Análisis de Políticas",
        description: "Agencias gubernamentales analizan métricas YFI para informar decisiones de políticas enfocadas en la juventud."
      }
    },
    quickStart: {
      title: "Inicio Rápido",
      subtitle: "Haz tu primera solicitud API en segundos. Copia este comando cURL y reemplaza con tu clave API."
    },
    copy: "Copiar",
    copied: "¡Copiado!",
    codeCopied: "Código copiado al portapapeles",
    copyFailed: "Error al copiar código",
    cta: {
      title: "¿Listo para Construir?",
      subtitle: "Genera tu clave API y comienza a construir con datos YFI hoy. Sin necesidad de tarjeta de crédito.",
      button: "Obtener Tu Clave API"
    }
  }
} as const;
